<template>
   <v-app>
       <form @submit.prevent="logIn">
           <v-card max-width="500px" class="mx-auto mt-16" outlined>
               <v-card-title class="mb-5">
                   <h1>Sign In Form</h1>
               </v-card-title>

               <v-card-text>
                   <v-text-field
                      prepend-inner-icon="mdi-account"
                      v-model="form.email"
                      class="form-control  "
                      placeholder="Enter your username"
                      type="email"
                      outlined
                      :error-messages="form.errors.email"
                  />

                   <v-text-field
                       v-model="form.password"
                       prepend-inner-icon="mdi-lock"
                       label="Password"
                       outlined
                       :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                       :type="showPassword ? 'text' : 'password'"
                       :error-messages="form.errors.password"
                       @click:append="showPassword = !showPassword"
                   />
                      <v-btn color="primary" block type="submit">
                          Submit
                      </v-btn>
               </v-card-text>
           </v-card>
       </form>
   </v-app>
</template>

<script>
export default {
    name: "Login",
    data(){
        return{

            form:this.$inertia.form({
                email:null,
                password:null,
            }),

            showPassword:false
        }
    },
    methods:{
        logIn(){
            this.form.post(route('loginStore'))
        }
    }
}
</script>
